import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl,baseUrl1 } from "../../constant/baseurl";
import { apiCall } from "../../api/index";
import { showLoading } from "../slice/loadingSlice";

const createAccountAsyncThunk = (method, type, contentType, url, baseURL=baseUrl) =>
  createAsyncThunk(type, async (payload, thunkAPI) => {
    const { data } = payload;
    const { dispatch } = thunkAPI;
    const token = localStorage.getItem("token");
    const apiRequest = {
      method: method,
      headers: token
        ? {
            "Content-Type": contentType,
            Authorization: "Token " + localStorage.getItem("token"),
          }
        : { "Content-Type": contentType },
      url: `${baseURL}${url}`,
      data,
    };

    try {
      dispatch(showLoading.actions.toggleLoading(true));
      const res = await apiCall(apiRequest, dispatch);
      const response = res.data;

      dispatch(showLoading.actions.toggleLoading(false));

      if (response.statusFlag === true) {
        console.log(`login action ------ ${type}`, response);
        return response;
      } else {
        console.error(`account action - ${type}`, response);

        // Check if there is an error code in the response
        const errorCode = response.message;

        // You can throw a custom error with the error code
        throw new Error(errorCode);
      }
    } catch (error) {
      dispatch(showLoading.actions.toggleLoading(false));
      throw error;
    }
  });

  export const getCvAnalysisData = createAccountAsyncThunk(
    "post",
    "getCvAnalysisData",
    "application/json",
    "valiantinfo_admin/admin_cv_analysis/admin_get_candidate_documents/"
  );

  export const addCvDiscrepancy = createAccountAsyncThunk(
    "post",
    "addCvDiscrepancy",
    "application/json",
    "valiantinfo_admin/admin_cv_analysis/admin_add_cv_discrepancy/"
  );

  export const sendMessage = createAccountAsyncThunk(
    "put",
    "sendMessage",
    "application/json",
    "valiantinfo_admin/admin_cv_analysis/admin_update_cv_discrepancy/"
  );

  export const concludeDiscrepancy = createAccountAsyncThunk(
    "put",
    "concludeDiscrepancy",
    "application/json",
    "valiantinfo_admin/admin_cv_analysis/admin_update_discrepancy_closed_status/"
  );

  export const followUpDiscrepancy = createAccountAsyncThunk(
    "put",
    "followUpDiscrepancy",
    "application/json",
    "valiantinfo_admin/admin_cv_analysis/update_followup_discrepancy_data/"
  );

  export const getAIdiscrepancy = createAccountAsyncThunk(
    "post",
    "getAIdiscrepancy",
    "application/json",
    "valiantinfo_admin/auto_gen_response/ai_cv_discrepancy_response/",
    baseUrl1
  );